"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var constants_1 = require("./constants");
var beacon_1 = require("./beacon");
var Eddystone = (function () {
    function Eddystone() {
    }
    Eddystone.prototype.request = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bluetooth, requestOptions, device;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bluetooth = navigator.bluetooth;
                        if (!bluetooth) {
                            return [2 /*return*/, Promise.reject('Your browser does not support Web Bluetooth.')];
                        }
                        requestOptions = { filters: [{ services: [constants_1.default.EDDYSTONE_CONFIG_SERVICE_UUID] }] };
                        return [4 /*yield*/, bluetooth.requestDevice(requestOptions)];
                    case 1:
                        device = _a.sent();
                        return [2 /*return*/, new beacon_1.Beacon(device)];
                }
            });
        });
    };
    return Eddystone;
}());
exports.Eddystone = Eddystone;
//# sourceMappingURL=Eddystone.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/eddystone-web-bluetooth/dist/Eddystone.js
// module id = 192
// module chunks = 0